module.exports = __webpack_public_path__ + "img/ico-facebook.74b0e2db.svg";